import React, { Component } from 'react'
import './ThemeIcon.css'

/*
	Icône de la bibliothèque (collection MongoDB icons) colorée à l'affichage.

	Rend le SVG neutre (champ svg / svg_filled) en inline : la couleur vient de
	la prop color (currentColor) et l'épaisseur du trait des variables CSS
	--icon-stroke-lineal / --icon-stroke-fill définies dans ThemeIcon.css.

	Si le document ne porte pas encore les champs SVG (base non régénérée),
	repli automatique sur les anciennes variantes pré-colorées (fill/lineal)
	via la prop legacyTheme ("blank" ou l'_id du thème).
*/
class ThemeIcon extends Component
{
	render()
	{
		const icon = this.props.icon
		if (!icon)
			return (null)
		const type = (this.props.type === "lineal") ? "lineal" : "fill"
		let svg = icon.svg
		if (type === "fill" && icon.svg_filled)
			svg = icon.svg_filled
		if (svg)
		{
			let classname = "theme-icon theme-icon--" + type
			if (this.props.className)
				classname += " " + this.props.className
			return (
				<span
					className={classname}
					style={{ color: this.props.color, ...this.props.style }}
					role="img"
					aria-label={this.props.alt}
					dangerouslySetInnerHTML={{ __html: svg }}
				></span>
			)
		}
		const variants = (type === "lineal") ? icon.lineal : icon.fill
		let prev = null
		if (variants)
		{
			for (let i = 0; i < variants.length; i++)
			{
				if (variants[i].theme === this.props.legacyTheme)
				{
					prev = variants[i].icon
					break
				}
			}
		}
		if (prev === null)
			return (null)
		return (<img src={prev} alt={this.props.alt} className={this.props.className} style={this.props.style} />)
	}
}

export default ThemeIcon
